<template>
  <div>
    <Topnav title="TRAINING VIDEOS" />
    <Sidebar />
    <div class="content-wrapper" style="background: white">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        loader="dots"
        :is-full-page="fullPage"
        :height="height"
        :width="width"
        background-color="#6b6969"
      />
      <div class="content-header">
        <div class="custom-container-fluid">
          <div class="row">
            <div class="col-md-6" v-for="(m, i) in modules" :key="i">
              <div
                class="card cursor-pointer"
                :class="[
                  m.status === 'available'
                    ? 'border'
                    : m.status === 'completed'
                    ? 'bg-ash text-dark'
                    : 'bg-disabled border',
                ]"
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <h3>{{ m.title }}</h3>
                    </div>
                    <div class="col-md-6">
                      <div
                        class="
                          text-green text-left text-md-right text-uppercase
                          mt-0 mt-md-4
                          mb-3 mb-md-0
                        "
                      >
                        {{ m.status }}
                      </div>
                    </div>
                    <div class="col-12">
                      <router-link :to="(m.status === 'available' || m.status === 'completed')?'/dashboard/courses/'+m.id:''" class="text-dark">
                        <p>
                          {{ m.description }}
                        </p>
                      </router-link>
                    </div>
                    <div class="col-md-4">
                      <span class="mr-2 mb-2">
                        <img
                          src="@/assets/logo_white.png"
                          style="
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;

                            background: black;
                          "
                          alt=""
                      /></span>
                      <span class="mt-1 mr-3">
                        {{ m.course_instructor_name }}</span
                      >
                    </div>
                    <div class="col-md-4">
                      <span class="material-icons"> play_circle_outline </span>
                      <span class="mr-4" style="vertical-align: super">
                        {{ m.video_count }} lessons</span
                      >
                    </div>
                    <div class="col-md-4">
                      <span class="material-icons"> schedule </span>
                      <span class="mt-1" style="vertical-align: super">
                        24mins</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import "vue-loading-overlay/dist/vue-loading.css";
// import '../../../public/plugins/datatables/jquery.dataTables.min.js';
// import 'datatables.net-select';
import Swal from "sweetalert2";

export default {
  name: "TrainingModules",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128,
      modules: [],
      reach_id: 2,
    };
  },
  components: {
    Loading: () => import("vue-loading-overlay"),
    Sidebar: () => import("@/components/Dashboard-sidebar"),
    // foot: () => import('@/components/footer_component'),
    Topnav: () => import("@/components/Dashboard-topnav"),
  },
  methods: {
    getModules() {
      this.isLoading = true;
      axios
        .get(`${process.env.VUE_APP_COMPANY_URL}/modules`)
        .then((res) => {
          this.modules = res.data.data;

          let current_module = this.modules.find((e) => {
            if (e.id == this.reach_id) {
              return e;
            }
          });
          let index =
            this.modules.indexOf(current_module) > 0
              ? this.modules.indexOf(current_module)
              : 0;

          this.modules = this.modules.map((e, i) => {
            if (i < index) {
              e.status = "completed";
            } else if (i == index) {
              e.status = "available";
            } else if (i > index) {
              e.status = "not available";
            }
            e["video_count"] = 0;
            e["CoachSchoolModuleTopics"].forEach((t) => {
              e["video_count"] =
                e["video_count"] + t["CoachSchoolModuleVideos"].length;
            });
            return e;
          });
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formatdate(date) {
      return date ? moment(date).format("dddd, MMMM D, YYYY") : "";
    },

    loadDatatable() {
      window.$("#example2").DataTable({
        order: [[1, "asc"]],
        paging: false,
        lengthChange: false,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,
        responsive: true,
      });
    },
  },
  async created() {
    window.$(".index-page").removeClass("sidebar-open");
    setTimeout(() => {
      window.$(".nav-link").removeClass("active");
      window.$("#videos").addClass("active");
    }, 100);
    this.getModules();
  },
};
</script>
<style scoped>
.card {
  box-shadow: none !important;
}
</style>



